import { useMiceQuotationRestoreModalStore } from "./mice-quotation-restore-modal.store";

export function useMiceQuotationRestoreModal() {
  const open = useMiceQuotationRestoreModalStore((s) => s.open);
  const close = useMiceQuotationRestoreModalStore((s) => s.close);

  return {
    open,
    close,
  };
}
